import { Form } from "react-bootstrap";
import { useRoleContext } from "../Providers/RoleProvider";

const NewDynamicSelect = ({
  value = "",
  isUpdated = false,
  isRequired = false,
  onChange,
  options = [],
  valueKey = "",
  inputWidth = 85,
  getOptionValue = (opt) => opt.name,
  getOptionLabel = (opt) => opt.name,
}) => {
  const { isAdmin } = useRoleContext();
  const normalizedValue = value ?? ""; // ✅ allow null -> ""

  const enabledOptions = options.filter((opt) => opt.enabled !== false);

  const currentOpt = options.find((o) => getOptionValue(o) === normalizedValue);
  const currentIsDisabled =
    normalizedValue !== "" && currentOpt?.enabled === false;

  const valueExistsInEnabled = enabledOptions.some(
    (o) => getOptionValue(o) === normalizedValue,
  );

  const requiredCheck = isRequired && !normalizedValue;

  let border = "1px solid #ced4da";
  if (requiredCheck) border = "2px solid red";
  else if (isUpdated) border = "2px solid #8bd1b1";

  const needsDisplayOnlyOption =
    normalizedValue !== "" && (currentIsDisabled || !valueExistsInEnabled);

  return (
    <Form.Select
      value={normalizedValue}
      disabled={!isAdmin}
      className="mt-1"
      style={{
        width: `${inputWidth}%`,
        border,
        color: currentIsDisabled ? "#adb5bd" : "#212529",
      }}
      onChange={(e) => {
        const selectedValue = e.target.value;
        const selectedOption = enabledOptions.find(
          (opt) => getOptionValue(opt) === selectedValue,
        );

        onChange({
          key: valueKey,
          value: selectedValue,
          option: selectedOption,
        });
      }}
    >
      {normalizedValue === "" && (
        <option value="" disabled hidden>
          {/* intentionally blank */}
        </option>
      )}

      {needsDisplayOnlyOption && normalizedValue !== "" && (
        <option
          value={normalizedValue}
          disabled
          hidden
          style={{ color: "#212529" }}
        >
          {currentOpt ? getOptionLabel(currentOpt) : normalizedValue}
        </option>
      )}

      {enabledOptions.map((opt) => (
        <option
          key={opt.id ?? getOptionValue(opt)}
          value={getOptionValue(opt)}
          style={{ color: "#212529" }}
        >
          {getOptionLabel(opt)}
        </option>
      ))}
    </Form.Select>
  );
};

export default NewDynamicSelect;
